import { createUseStyles } from 'react-jss'

import { COLOR, MQ } from 'utils/constants'

export const useStyles = createUseStyles({
  button: {
    borderRadius: 8,
    backgroundColor: COLOR.DARK_GREEN,
    color: COLOR.OFF_WHITE,
  },
  buttonText: {
    padding: [15, 24, 12],
    textDecoration: 'none',
    display: 'inline-block',
    color: COLOR.OFF_WHITE,

    [MQ.DESKTOP]: {
      padding: [15, 36, 13],
    },
  },
  lightGreen: {
    backgroundColor: COLOR.LIGHT_GREEN,
    color: COLOR.OFF_WHITE,
    border: `5px solid ${COLOR.LIGHT_GREEN}`,

    '&:active': {
      transition: '0.1s',
      transform: 'scale(1.1)',
      '& a': {
        '& span': {
          color: COLOR.OFF_WHITE,
        },
      },
    },
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0)',
      '& a': {
        '& span': {
          color: COLOR.LIGHT_GREEN,
        },
      },
      '&:active': {
        backgroundColor: COLOR.LIGHT_GREEN,
        transition: '0.1s',
      },
    },
  },
  darkGreen: {
    backgroundColor: COLOR.DARK_GREEN,
    color: COLOR.OFF_WHITE,
    border: `5px solid ${COLOR.DARK_GREEN}`,

    '&:active': {
      transition: '0.1s',
      transform: 'scale(1.1)',
      '& a': {
        '& span': {
          color: COLOR.OFF_WHITE,
        },
      },
    },
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0)',
      '& a': {
        '& span': {
          color: COLOR.DARK_GREEN,
        },
      },
      '&:active': {
        backgroundColor: COLOR.DARK_GREEN,
        transition: '0.1s',
      },
    },
  },

  orange: {
    backgroundColor: COLOR.ORANGE,
    color: COLOR.OFF_WHITE,
    border: `5px solid ${COLOR.ORANGE}`,
    '&:active': {
      transition: '0.1s',
      transform: 'scale(1.1)',
      '& a': {
        '& span': {
          color: COLOR.OFF_WHITE,
        },
      },
    },
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0)',
      '& a': {
        '& span': {
          color: COLOR.ORANGE,
        },
      },
      '&:active': {
        backgroundColor: COLOR.ORANGE,
        transition: '0.1s',
      },
    },
    '& a': {
      '& span': {
        color: COLOR.OFF_WHITE,
      },
    },
  },

  yellow: {
    backgroundColor: COLOR.YELLOW,
    color: COLOR.OFF_WHITE,
    border: `5px solid ${COLOR.YELLOW}`,
    '&:active': {
      transition: '0.1s',
      transform: 'scale(1.1)',
      '& a': {
        '& span': {
          color: COLOR.YELLOW,
        },
      },
    },
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0)',
      '& a': {
        '& span': {
          color: COLOR.YELLOW,
        },
      },
      '&:active': {
        backgroundColor: COLOR.YELLOW,
        transition: '0.1s',
      },
    },
    '& a': {
      '& span': {
        color: COLOR.OFF_WHITE,
      },
    },
  },
  round: {
    borderRadius: 58,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0)',
      '& a': {
        '& span': {
          color: COLOR.OFF_WHITE,
        },
      },
    },
  },
})
